import { Link } from "react-router-dom";
import { Bed, Bath, Maximize2 } from "lucide-react";
import SaveHeart from "./SaveHeart";
import HoverCyclePhoto from "./HoverCyclePhoto";

/**
 * MlsFeaturedCard — editorial-style portrait card for a live MLS listing.
 * Visually mirrors PropertyCard but routes to /mls-listings/{listing_key}.
 */
export default function MlsFeaturedCard({ l }) {
  const price = l.price ? `$${Number(l.price).toLocaleString()}` : "—";

  return (
    <Link
      to={`/mls-listings/${l.listing_key}`}
      className="group block bg-white card-lift"
      data-testid={`mls-featured-card-${l.listing_key}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-stone-100">
        <HoverCyclePhoto
          photos={l.photos || []}
          alt={l.address}
          className="w-full h-full object-cover"
        />
        <span className="absolute top-4 left-4 bg-white/95 backdrop-blur text-[#0A0A0A] text-[9px] uppercase tracking-[0.3em] font-medium px-3 py-1.5">
          Live · MLS
        </span>
        <span
          className={`absolute top-4 right-4 text-[9px] uppercase tracking-[0.3em] font-medium px-3 py-1.5 ${
            l.status === "Active"
              ? "bg-white/95 text-[#0A0A0A]"
              : l.status === "Pending"
              ? "bg-amber-100/95 text-amber-900"
              : "bg-stone-200/95 text-stone-700"
          }`}
        >
          {l.status || "Active"}
        </span>
        <SaveHeart
          listingKey={l.listing_key}
          address={l.address}
          className="absolute bottom-4 right-4"
        />
      </div>
      <div className="pt-6 pb-2">
        <div className="eyebrow text-gray-500 mb-2">
          {l.city}
          {l.property_type ? ` · ${l.property_type}` : ""}
        </div>
        <h3 className="font-display text-2xl lg:text-[28px] leading-tight text-[#0A0A0A] mb-1">
          {l.address}
        </h3>
        <div className="text-sm text-gray-500 line-clamp-1">
          {l.city}
          {l.state ? `, ${l.state}` : ""} {l.zip || ""}
        </div>
        <div className="flex items-baseline justify-between mt-5 pt-5 border-t border-stone-200">
          <div className="font-display serif-italic text-3xl text-[#E63946]">
            {price}
          </div>
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <span className="flex items-center gap-1.5">
              <Bed className="w-3.5 h-3.5" strokeWidth={1.5} /> {l.beds ?? "—"}
            </span>
            <span className="flex items-center gap-1.5">
              <Bath className="w-3.5 h-3.5" strokeWidth={1.5} /> {l.baths ?? "—"}
            </span>
            <span className="flex items-center gap-1.5">
              <Maximize2 className="w-3.5 h-3.5" strokeWidth={1.5} />{" "}
              {l.sqft ? Number(l.sqft).toLocaleString() : "—"}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
